import { render, staticRenderFns } from "./handleLxps.vue?vue&type=template&id=28d67f92&scoped=true&"
import script from "./handleLxps.vue?vue&type=script&lang=js&"
export * from "./handleLxps.vue?vue&type=script&lang=js&"
import style0 from "./handleLxps.vue?vue&type=style&index=0&id=28d67f92&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d67f92",
  null
  
)

export default component.exports